import type { FC } from "react";
import { useEffect, useState } from "react";
import type { MatchCardsListsAppenderComponent } from "@motain/xpa-proto-files-web/lib/types/match_cards_lists_appender";
import { MatchCardsList } from "@/xpa-components/match-cards-list/MatchCardsList";
import { isNonNullable } from "@/types/isNonNullable";
import styles from "./MatchCardsListsAppender.module.scss";
import { Button } from "@/components/button/Button";
import { getAllMatches } from "./getAllMatches";
import type { MatchCardsListComponent } from "@motain/xpa-proto-files-web/lib/types/match_cards_list";
import { isNullable } from "@/types/isNullable";
import { trackingService } from "@/modules/analytics";
import { EventType } from "@motain/xpa-proto-files-web/lib/types/tracking";

export const MatchCardsListsAppender: FC<MatchCardsListsAppenderComponent> = (
  props,
) => {
  const { lists, loadMoreButton } = props;
  const [extraList, setMatchCardsList] = useState<
    Array<MatchCardsListComponent>
  >([]);

  //Button is enabled if there is no request in progress
  const [isButtonEnabled, setIsButtonEnabled] = useState<boolean>(true);

  useEffect(() => {
    setMatchCardsList([]);
  }, [props]);

  const fetchMoreMatches = async () => {
    if (isNullable(loadMoreButton)) {
      return;
    }

    setIsButtonEnabled(false);

    const additionalMatches = await getAllMatches(loadMoreButton.apiUrl);

    if (isNonNullable(additionalMatches)) {
      const newMatchList = extraList.concat(additionalMatches.lists);
      setMatchCardsList(newMatchList);
      return;
    }
    setIsButtonEnabled(true);
  };

  return (
    <div className={styles.container}>
      {lists.map((list, index) => {
        if (isNullable(list)) {
          return null;
        }

        return (
          <MatchCardsList
            key={`MatchCardList-${index}`}
            {...list}
          ></MatchCardsList>
        );
      })}
      {extraList.length > 0 &&
        extraList.map((list, index) => {
          if (isNullable(list)) {
            return null;
          }

          return (
            <MatchCardsList
              key={`MatchCardList-${index}`}
              {...list}
            ></MatchCardsList>
          );
        })}

      {isNonNullable(loadMoreButton) && (
        <div className={styles.loadAllButton}>
          <Button
            disabled={!isButtonEnabled}
            onClick={() => {
              void fetchMoreMatches();

              trackingService.sendXpaTracking(
                loadMoreButton.trackingEvents,
                EventType.EVENT_CLICK,
              );
            }}
          >
            {loadMoreButton.name}
          </Button>
        </div>
      )}
    </div>
  );
};
